import IconBool from "components/IconBool";

const MiniQPrev = ({item, t}) => {
    return (
        <>
            <div className="preview-item">
                <label>{t("power")}</label>
                <div className="preview-input">{item.values.power}</div>
            </div>
            <div className="preview-item">
                <div className="row">
                    <div className="col-6">
                        <label>{t("vacuum")}</label>
                        <div className="preview-input"><IconBool value={item.has.vacuum}/> {item.values.vacuum}</div>
                    </div>
                    <div className="col-6">
                        <label>{t("filling")}</label>
                        <div className="preview-input"><IconBool value={item.has.filling}/> {item.values.filling}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MiniQPrev;